import * as ambassadorWixAddonsV1AddOn from './addons-v1-add-on-add-ons.http.js';
import * as ambassadorWixAddonsV1AddOnTypes from './addons-v1-add-on-add-ons.types.js';
import * as ambassadorWixAddonsV1AddOnUniversalTypes from './addons-v1-add-on-add-ons.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createAddOn(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAddonsV1AddOnUniversalTypes.CreateAddOnRequest,
  ambassadorWixAddonsV1AddOnTypes.CreateAddOnRequest,
  ambassadorWixAddonsV1AddOnUniversalTypes.CreateAddOnResponse,
  ambassadorWixAddonsV1AddOnTypes.CreateAddOnResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixAddonsV1AddOn.createAddOn(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/add-ons',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAddOn(): __PublicMethodMetaInfo<
  'GET',
  { addOnId: string },
  ambassadorWixAddonsV1AddOnUniversalTypes.GetAddOnRequest,
  ambassadorWixAddonsV1AddOnTypes.GetAddOnRequest,
  ambassadorWixAddonsV1AddOnUniversalTypes.GetAddOnResponse,
  ambassadorWixAddonsV1AddOnTypes.GetAddOnResponse
> {
  const payload = { addOnId: ':addOnId' } as any;

  const getRequestOptions = ambassadorWixAddonsV1AddOn.getAddOn(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/add-ons/{addOnId}',
    pathParams: { addOnId: 'addOnId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateAddOn(): __PublicMethodMetaInfo<
  'PATCH',
  { addOnId: string },
  ambassadorWixAddonsV1AddOnUniversalTypes.UpdateAddOnRequest,
  ambassadorWixAddonsV1AddOnTypes.UpdateAddOnRequest,
  ambassadorWixAddonsV1AddOnUniversalTypes.UpdateAddOnResponse,
  ambassadorWixAddonsV1AddOnTypes.UpdateAddOnResponse
> {
  const payload = { addOn: { id: ':addOnId' } } as any;

  const getRequestOptions = ambassadorWixAddonsV1AddOn.updateAddOn(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/add-ons/{addOn.id}',
    pathParams: { addOnId: 'addOnId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteAddOn(): __PublicMethodMetaInfo<
  'DELETE',
  { addOnId: string },
  ambassadorWixAddonsV1AddOnUniversalTypes.DeleteAddOnRequest,
  ambassadorWixAddonsV1AddOnTypes.DeleteAddOnRequest,
  ambassadorWixAddonsV1AddOnUniversalTypes.DeleteAddOnResponse,
  ambassadorWixAddonsV1AddOnTypes.DeleteAddOnResponse
> {
  const payload = { addOnId: ':addOnId' } as any;

  const getRequestOptions = ambassadorWixAddonsV1AddOn.deleteAddOn(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/add-ons/{addOnId}',
    pathParams: { addOnId: 'addOnId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryAddOns(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixAddonsV1AddOnUniversalTypes.QueryAddOnsRequest,
  ambassadorWixAddonsV1AddOnTypes.QueryAddOnsRequest,
  ambassadorWixAddonsV1AddOnUniversalTypes.QueryAddOnsResponse,
  ambassadorWixAddonsV1AddOnTypes.QueryAddOnsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixAddonsV1AddOn.queryAddOns(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/add-ons/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateAddOns(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAddonsV1AddOnUniversalTypes.BulkCreateAddOnsRequest,
  ambassadorWixAddonsV1AddOnTypes.BulkCreateAddOnsRequest,
  ambassadorWixAddonsV1AddOnUniversalTypes.BulkCreateAddOnsResponse,
  ambassadorWixAddonsV1AddOnTypes.BulkCreateAddOnsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAddonsV1AddOn.bulkCreateAddOns(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/add-ons/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateAddOns(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAddonsV1AddOnUniversalTypes.BulkUpdateAddOnsRequest,
  ambassadorWixAddonsV1AddOnTypes.BulkUpdateAddOnsRequest,
  ambassadorWixAddonsV1AddOnUniversalTypes.BulkUpdateAddOnsResponse,
  ambassadorWixAddonsV1AddOnTypes.BulkUpdateAddOnsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAddonsV1AddOn.bulkUpdateAddOns(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/add-ons/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteAddOns(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAddonsV1AddOnUniversalTypes.BulkDeleteAddOnsRequest,
  ambassadorWixAddonsV1AddOnTypes.BulkDeleteAddOnsRequest,
  ambassadorWixAddonsV1AddOnUniversalTypes.BulkDeleteAddOnsResponse,
  ambassadorWixAddonsV1AddOnTypes.BulkDeleteAddOnsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAddonsV1AddOn.bulkDeleteAddOns(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/add-ons/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AddOn as AddOnOriginal,
  AddOnAddOnInfoOneOf as AddOnAddOnInfoOneOfOriginal,
  Money as MoneyOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  CreateAddOnRequest as CreateAddOnRequestOriginal,
  CreateAddOnResponse as CreateAddOnResponseOriginal,
  GetAddOnRequest as GetAddOnRequestOriginal,
  GetAddOnResponse as GetAddOnResponseOriginal,
  UpdateAddOnRequest as UpdateAddOnRequestOriginal,
  UpdateAddOnResponse as UpdateAddOnResponseOriginal,
  DeleteAddOnRequest as DeleteAddOnRequestOriginal,
  DeleteAddOnResponse as DeleteAddOnResponseOriginal,
  QueryAddOnsRequest as QueryAddOnsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryAddOnsResponse as QueryAddOnsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  QueryLocalizedAddOnsRequest as QueryLocalizedAddOnsRequestOriginal,
  QueryLocalizedAddOnsResponse as QueryLocalizedAddOnsResponseOriginal,
  BulkCreateAddOnsRequest as BulkCreateAddOnsRequestOriginal,
  BulkCreateAddOnsResponse as BulkCreateAddOnsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkAddOnResult as BulkAddOnResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateAddOnsRequest as BulkUpdateAddOnsRequestOriginal,
  MaskedAddOn as MaskedAddOnOriginal,
  BulkUpdateAddOnsResponse as BulkUpdateAddOnsResponseOriginal,
  BulkUpdateAddOnsResponseBulkAddOnResult as BulkUpdateAddOnsResponseBulkAddOnResultOriginal,
  BulkDeleteAddOnsRequest as BulkDeleteAddOnsRequestOriginal,
  BulkDeleteAddOnsResponse as BulkDeleteAddOnsResponseOriginal,
  BulkDeleteAddOnsResponseBulkAddOnResult as BulkDeleteAddOnsResponseBulkAddOnResultOriginal,
  BulkUpdateAddOnTagsRequest as BulkUpdateAddOnTagsRequestOriginal,
  BulkUpdateAddOnTagsResponse as BulkUpdateAddOnTagsResponseOriginal,
  BulkUpdateAddOnTagsResult as BulkUpdateAddOnTagsResultOriginal,
  BulkUpdateAddOnTagsByFilterRequest as BulkUpdateAddOnTagsByFilterRequestOriginal,
  BulkUpdateAddOnTagsByFilterResponse as BulkUpdateAddOnTagsByFilterResponseOriginal,
  SitePropertiesNotification as SitePropertiesNotificationOriginal,
  SitePropertiesEvent as SitePropertiesEventOriginal,
  Properties as PropertiesOriginal,
  Categories as CategoriesOriginal,
  Locale as LocaleOriginal,
  Address as AddressOriginal,
  AddressHint as AddressHintOriginal,
  PlacementType as PlacementTypeOriginal,
  PlacementTypeWithLiterals as PlacementTypeWithLiteralsOriginal,
  GeoCoordinates as GeoCoordinatesOriginal,
  BusinessSchedule as BusinessScheduleOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  Multilingual as MultilingualOriginal,
  SupportedLanguage as SupportedLanguageOriginal,
  ResolutionMethod as ResolutionMethodOriginal,
  ResolutionMethodWithLiterals as ResolutionMethodWithLiteralsOriginal,
  ConsentPolicy as ConsentPolicyOriginal,
  Translation as TranslationOriginal,
  ChangeContext as ChangeContextOriginal,
  ChangeContextPayloadOneOf as ChangeContextPayloadOneOfOriginal,
  PropertiesChange as PropertiesChangeOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCloned as SiteClonedOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './addons-v1-add-on-add-ons.types.js';
